import axios from './Api';

export function UploadDocument(data = new FormData(), params?: Documents.IImportFileParams, options: Axios.IOptions = {}) {
  return axios.post<Documents.IImportFile>('/documents/', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress,
    params
  });
}

export function ListDocuments(params: Documents.IListFilesParams) {
  return axios.get<Documents.IDocument[]>('/documents', { params });
}

export function GetArchive(params: Documents.IArchiveParams) {
  return axios.get<Documents.IArchive>('/documents/zip', { params });
}

export function GetCityHallStatistics(params: Documents.IGetCityHallStatisticsParams) {
  return axios.get<Documents.GetDocumentResponse>('/documents/document-report', { params, responseType: 'blob' });
}

export function GetDocument(id: number) {
  return axios.get<Documents.GetDocumentResponse>(`/documents/${id}`, { responseType: 'blob' });
}

export function ListDocumentsUtilities(params: Documents.IListDocumentsUtilitiesParams) {
  return axios.get<Documents.GetListDocumentsUtilitiesResponse>('/documents/utilities', { params });
}
